import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
    inject,
} from "@angular/core";
import { CerrixInputValidationRequiredDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-required.directive";

@Component({
    selector: "cerrix-textarea",
    standalone: true,
    templateUrl: "./cerrix-textarea.component.html",
    styleUrl: "./cerrix-textarea.component.scss",
    encapsulation: ViewEncapsulation.None,
    host: {
        "(click)": "$event.stopPropagation()",
    },
})
export class CerrixTextareaComponent {
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean | null = null;
    @Input() required: boolean = false;
    @Input() resize: boolean = false;
    @Input() name: string = "";
    @Input() rows: number = 4;
    @Input() value: string = "";
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

    // Required is normally declared by putting the appValidationRequired directive on this
    // field or on the component it sits in. The input above stays for the older components that
    // set it directly, and for those the search below simply finds nothing.
    private requiredMarker = inject(CerrixInputValidationRequiredDirective, { optional: true });

    protected get isRequired(): boolean {
        return this.required || (this.requiredMarker?.appValidationRequired ?? false);
    }
}
